<!------------------------------------------------------------------------------
  Copyright (c) 2019. Keni Williams <kenneth.williams@estuk.co.uk>

  This file CheckoutEmail.vue is part of event_pass_client.dev.
  Unauthorized copying of this file, via any medium is strictly prohibited.
  Proprietary and confidential
  CheckoutEmail.vue can not be copied and/or distributed
  without the express permission of Keni Williams <kenneth.williams@estuk.co.uk>
  ----------------------------------------------------------------------------->

<template>
    <div class="card-body container">
        <div class="mb-2">
            <h5 class="h5 d-flex align-items-center mb-0"><i class="material-icons pr-1" aria-hidden="true">email</i>
                <strong class="mr-1">Step {{step}}:</strong> <span>Email</span></h5>
            <small class="text-muted d-block">Enter your email address below to receive booking confirmation</small>
        </div>
        <!--        <div class="position-relative">-->
        <!--            <PostCode name="postcode"-->
        <!--                      :maps_region="maps_region"-->
        <!--                      :maps_api_key="maps_api_key"-->
        <!--                      explain="We need would like to know where you are coming from"></PostCode>-->
        <!--        </div>-->
        <div class="position-relative md-form">
            <input type="email"
                   data-value-missing=”Required”
                   :pattern="pattern"
                   id="guest_email"
                   class="form-control"
                   name="guest_email"
                   aria-describedby="emailHelpBlockMD"
                   data-pattern-mismatch="Invalid email address"

                   v-model="email_model"
                   :disabled="disabled"
                   required>
            <div class="invalid-feedback"
                 :class="{
                    'd-block':email_valid === false
                }"
            >
                Your email address doesnt look right?
            </div>
            <label for="guest_email">Enter email address</label>
        </div>
        <transition name="fade">

            <div v-if="email_valid"
                 id="guest_email-confirm-div"
                 class="position-relative md-form">
                <input type="email"
                       id="guest_email-confirm"
                       class="form-control"
                       aria-describedby="emailConfirmHelpBlockMD"
                       data-value-missing=”Required”

                       v-model="email_match_model"
                       :disabled="disabled"
                       required>
                <label for="guest_email-confirm"> type email again</label>
                <div class="invalid-feedback"
                     :class="{
                        'd-block':email_match === false
                     }"
                >
                    email does not match
                </div>
            </div>
        </transition>
    </div>


</template>

<script>
    import {_} from 'underscore';

    export default {
        name: "checkout-email",
        props: {
            auth_email: {
                type: String,
                default: null
            },
            maps_region: {
                type: String,
                default: null
            },
            maps_api_key: {
                type: String,
                default: null
            },
            step: {
                type: Number,
                default: 1
            },
            devMode: {
                type: Boolean,
                default: false
            },
            disabled: {
                type: Boolean,
                default: false
            },
        },
        mounted() {
            if (this.devMode) {
                this.email_model = this.devMode ? 'kenneth.williams@estuk.co.uk' : this.auth_email
                                                                                   ? this.auth_email
                                                                                   : null;
                this.email_match_model = this.devMode ? 'kenneth.williams@estuk.co.uk' : this.auth_email
                                                                                         ? this.auth_email
                                                                                         : null;
            } else {
                this.email_model = this.auth_email;
                this.email_match_model = this.auth_email;
            }

        },
        data() {
            return {
                pattern: `[a-z0-9!#$%&'*+/=?^_\`{|}~-]+(?:\\.[a-z0-9!#$%&'*+/=?^_\`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?`,
                email_model: '',
                email_match_model: '',
                email_valid: null,
                email_match: null
            }
        },
        methods: {
            validEmail() {
                let self = this;

                if (_.isEmpty(self.email_model)) {
                    return false;
                }
                let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                let testInput = re.test(self.email_model);

                if (testInput) {
                    self.email_valid = true;
                } else {
                    self.email_valid = false
                }
                if (testInput) {
                    self.$emit('trigger_pause', {
                        target: 'email_first',
                        start: false
                    })
                }else{
                    self.$emit('trigger_pause', {
                        target: 'email_first',
                        start: true
                    });
                }
                return testInput;
            }
        },
        watch: {
            email_model() {
                let self = this;

                self.validEmail();

            },
            email_match_model(val) {
                let self = this;


                if (_.isEmpty(val)) {
                    self.email_match = null;
                } else if (val !== self.email_model) {
                    self.$emit('trigger_pause', {
                        target: 'email_match',
                        start: true
                    });
                    self.email_match = false;
                } else {
                    self.$emit('trigger_pause', {
                        target: 'email_match',
                        start: false
                    });
                    self.email_match = true;
                }

                self.$emit('email_valid', self.email_match)
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// resources/assets/js/components/checkout/CheckoutEmail.vue